import { useNavigate } from 'react-router-dom'

import { CardMenu } from '@/modules/report/components/menu-navigation-card/card'
import { Layout } from '@/modules/shared/layouts/layout'

export function Report() {
  const navigate = useNavigate()

  const handleBackPage = () => {
    navigate('/')
  }

  return (
    <Layout pageTitle="Relatórios" handleGoBack={handleBackPage}>
      <div className="w-full px-4 md:px-0 max-w-[580px] mx-auto">
        <CardMenu menuType="report" />
      </div>
    </Layout>
  )
}
